import { IOpportunity } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { TCrudType } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/opportunities/models'

import { Dropdown } from 'core-components/library/dropdown'
import { Input } from 'core-components/library/inputs'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { onChangeNumInput } from '../../../helpers/onChangeNumInput'
import { FinancialInput } from '../../styledComponents/financialInput/FinancialInput'
import { IColumn } from '../../styledComponents/styledTable/types'
import styles from '../Opportunities.module.scss'

interface IProps {
  onChange: (field: string, index: number) => (value: string | number) => void
  yearsAndQuartersSource: TCrudType
  businessTypeSource: TCrudType
}

export const getOpportunitiesColumns = ({
  onChange,
  yearsAndQuartersSource,
  businessTypeSource,
}: IProps): IColumn<IOpportunity>[] => {
  return [
    {
      title: getFormedEltTranslation('TopDeal'),
      field: 'TopDeal',
      width: 280,
      renderComponent: ({ value, index }) => (
        <Input
          classes={{
            root: styles.input,
          }}
          value={value || ''}
          onChange={onChange('TopDeal', index)}
        />
      ),
    },
    {
      title: getFormedEltTranslation('TotalUSD'),
      field: 'TotalUSD',
      renderComponent: ({ value, index }) => (
        <FinancialInput
          className={styles.input}
          value={value || ''}
          type={'number'}
          onChange={onChangeNumInput({ onChange: onChange('TotalUSD', index) })}
        />
      ),
    },
    {
      title: getFormedEltTranslation('BusinessType'),
      field: 'BusinessType',
      renderComponent: ({ value, index }) => (
        <Dropdown
          classes={{
            controlClasses: {
              root: styles.input,
            },
          }}
          caption={'label'}
          source={businessTypeSource}
          value={value || ''}
          onChange={onChange('BusinessType', index)}
        />
      ),
    },
    {
      title: getFormedEltTranslation('CloseDate'),
      field: 'CloseDate',
      renderComponent: ({ value, index }) => (
        <Dropdown
          classes={{
            controlClasses: {
              root: styles.input,
            },
          }}
          caption={'label'}
          source={yearsAndQuartersSource}
          value={value || ''}
          onChange={onChange('CloseDate', index)}
        />
      ),
    },
  ]
}
